<template>
  <div>
    <div class="fix-wrapper">
      <breadcrumb
        :crumbs="[
          $t('menu.quotations'),
          $t('text.create') + '：' + customer.name,
        ]"
      ></breadcrumb>

      <div class="search with-narrows">
        <el-form
          :inline="true"
          @submit.native.prevent="search"
          :model="searchForm"
          size="small"
        >
          <el-form-item>
            <el-input
              v-model.trim="searchForm.productNo"
              :placeholder="$t('product.productNo')"
              size="small"
            />
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              native-type="submit"
            />
          </el-form-item>
        </el-form>
      </div>
      <br />

      <div class="container">
        <el-form ref="productForm" label-width="80px" size="small">
          <div class="pd20">
            <sticky
              :sticky-top="50"
              :viewport="1024"
              :is-rem="false"
              style="min-height: 52px"
            >
              <vxe-toolbar zoom class="table-toolbar">
                <template v-slot:buttons>
                  <el-button
                    type="primary"
                    size="mini"
                    @click="batchDiscount"
                    >{{ $t("action.batchDiscount") }}</el-button
                  >
                </template>
              </vxe-toolbar>
            </sticky>
            <vxe-table
              :data="records"
              :loading="loading"
              id="recordsTable"
              row-id="id"
              ref="recordsTable"
              class="recordsTable"
              size="mini"
              resizable
              round
              highlight-hover-row
              auto-resize
              :scroll-y="{ enabled: false }"
            >
              <vxe-table-column type="seq" width="40"></vxe-table-column>
              <vxe-table-column type="expand" width="40">
                <template v-slot:content="{ row }">
                  <el-row
                    v-if="row.quotationSizePrices.length != 0"
                    :gutter="10"
                  >
                    <el-col
                      v-for="(
                        quotationSizePrice, index
                      ) in row.quotationSizePrices"
                      :key="index"
                      :span="4"
                    >
                      <el-input
                        size="small"
                        v-model.trim="quotationSizePrice.price"
                      >
                        <template slot="prepend">
                          <div>
                            <raw-html-limit-number
                              :content="quotationSizePrice.size"
                              :number="6"
                            />
                          </div>
                        </template>
                      </el-input>
                    </el-col>
                  </el-row>
                  <div v-else class="center grey">
                    {{ $t("prompt.noProductSize") }}
                  </div>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="images"
                :title="$t('product.images')"
                width="80"
              >
                <template v-slot="{ row }">
                  <thumbnail
                    :images="row.product.images"
                    width="40"
                    height="40"
                  />
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="productNo"
                :title="$t('product.productNo')"
              >
                <template v-slot="{ row }">
                  <span v-if="row.product.verifyAt != null" class="green font10"
                    >({{ $t("product.verify") }})</span
                  >
                  <span>{{ row.product.productNo }}</span>
                  <div v-if="row.product.productNoAlias != null" class="font10">
                    {{ $t("product.alias") }}: {{ row.product.productNoAlias }}
                  </div>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="product.categoryName"
                :title="$t('product.category')"
                width="120"
              />
              <vxe-table-column
                field="salesPrice"
                :title="$t('product.salesPrice')"
                width="120"
              >
                <template v-slot="{ row }">
                  <currency
                    :code="row.product.salesCurrency"
                    v-if="row.product.salesPrice != null"
                  ></currency
                  >{{ row.product.salesPrice }}</template
                >
              </vxe-table-column>
              <vxe-table-column
                field="hasInv"
                :title="$t('quotation.hasInv')"
                width="100"
              >
                <template v-slot="{ row }">
                  <el-checkbox size="small" v-model="row.hasInv"></el-checkbox>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="price"
                :title="$t('quotation.price') + '(¥)'"
                width="200"
              >
                <template v-slot="{ row }">
                  <el-input
                    size="small"
                    v-model.trim="row.price"
                    :placeholder="
                      $t('rules.mustFillSimple', [$t('quotation.price')])
                    "
                  />
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="action"
                :title="$t('text.action')"
                width="50"
              >
                <template v-slot="{ row, rowIndex }">
                  <el-button
                    type="text"
                    size="mini"
                    @click="removeRow(rowIndex)"
                    >{{ $t("text.remove") }}</el-button
                  >
                </template>
              </vxe-table-column>
            </vxe-table>
            <div class="pager center">
              <span v-if="records.length != 0">
                <span v-if="records.length == pager.total" class="grey">{{
                  $t("prompt.loadingComplete")
                }}</span>
                <span v-if="loadingBeyondMaxQtyDF" sclass="grey">{{
                  $t("prompt.loading500")
                }}</span>
                <el-button
                  v-if="
                    loadingMoreDF &&
                    records.length != pager.total &&
                    !loadingBeyondMaxQtyDF
                  "
                  type="text"
                  :loading="loadingMoreDoing"
                  @click="loadingMore"
                  >{{ $t("prompt.loadingMore") }}</el-button
                >
              </span>
            </div>
          </div>
          <div class="form-footer">
            <el-button
              type="primary"
              size="medium"
              plain
              :loading="saveDoing"
              @click="saveSubmit"
              >{{ $t("text.submit") }}</el-button
            >
            <back-button />
          </div>
        </el-form>
      </div>

      <!-- 批量折扣 -->
      <el-dialog
        :title="$t('action.batchDiscount')"
        :close-on-click-modal="false"
        :visible.sync="batchDiscountDF"
        width="30%"
      >
        <el-form
          ref="batchDiscountForm"
          :model="batchDiscountObj"
          label-width="80px"
        >
          <el-form-item
            :label="$t('quotation.original')"
            :prop="'discount'"
            :rules="[
              {
                required: true,
                message: $t('rules.required', [$t('quotation.discount')]),
                trigger: 'blur',
              },
            ]"
          >
            <el-input
              size="small"
              v-model.number="batchDiscountObj.discount"
              type="mumber"
              min="0"
              max="100"
            >
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button
            type="success"
            plain
            size="small"
            :loading="batchDiscountSubmitDoing"
            @click="batchDiscountSubmit('submit')"
            >{{ $t("text.submit") }}</el-button
          >
          <el-button size="small" @click="batchDiscountDF = false">{{
            $t("text.close")
          }}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import ls from "store2";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import BackButton from "@/components/BackButton";
import Currency from "@/components/Currency";

import Product from "@/api/product.js";
import Customer from "@/api/customer.js";
import Quotation from "@/api/quotation.js";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: { BackButton, Currency },
  data() {
    return {
      Util: Util,
      searchForm: {
        productNo: null,
        customerId: null,
        currentPage: null,
        pageSize: null,
      },
      // products: [],
      customer: { name: null },
      maxQty: 500,
      loadingMoreDF: false,
      loadingBeyondMaxQtyDF: false,
      //
      loadingMoreDoing: false,
      saveDoing: false,
      //
      // 批量折扣
      batchDiscountDF: false,
      batchDiscountObj: {
        discount: 100,
      },
      batchDiscountSubmitDoing: false,
      submitDoing: false,
    };
  },

  computed: {
    implicit() {
      return {
        customerId: this.$route.params.id,
      };
    },
  },
  created() {
    const self = this;
    Customer.findById(self.$route.params.id).then(function (res) {
      if (res.data.code === 200) {
        self.customer = res.data.entity;
      } else {
        self.sysError();
      }
    });
  },
  methods: {
    batchDiscount() {
      this.batchDiscountSubmitDoing = false;
      this.batchDiscountDF = true;
    },

    batchDiscountSubmit() {
      const self = this;
      self.$refs.batchDiscountForm.validate((valid) => {
        if (valid) {
          self.batchDiscountSubmitDoing = true;
          if (self.records.length !== 0) {
            for (const p of self.records) {
              p.price = Util.toFixed(
                (p.product.salesPrice * self.batchDiscountObj.discount) / 100,
                2
              );
            }
          }
          self.batchDiscountSubmitDoing = false;
          self.batchDiscountDF = false;
        } else {
          return false;
        }
      });
    },

    removeRow(idx) {
      this.records.splice(idx, 1);
    },

    saveSubmit() {
      const self = this;
      if (self.records.length === 0) {
        this.$message({
          message: self.$t("prompt.atLeastOneData"),
          type: "warning",
        });
        return;
      }
      let data = [];
      for (const p of self.records) {
        if (!Util.regexPrice(p.price)) {
          this.$message({
            message: self.$t("rules.regex", [self.$t("quotation.price")]),
            type: "warning",
          });
          return;
        }
        const quotationSizePricesFilter = p.quotationSizePrices.filter(
          (p) => p.price != null && p.price !== ""
        );
        if (quotationSizePricesFilter.length !== 0) {
          for (const f of quotationSizePricesFilter) {
            if (!Util.regexPrice(f.price)) {
              this.$message({
                message: self.$t("rules.regex", [
                  self.$t("quotation.sizePrice"),
                ]),
                type: "warning",
              });
              return;
            }
          }
        }
        const obj = {
          productId: p.product.id,
          price: p.price,
          hasInv: p.hasInv,
          inquirierId: self.customer.sourceTenantId,
          quoterId: self.Permit.currentTenant().id,
          quoterName: self.Permit.currentUser().name,
          customerId: self.customer.id,
          customerName: self.customer.name,
          quotationSizePrices: quotationSizePricesFilter,
        };
        data.push(obj);
      }
      self.saveDoing = true;
      Quotation.insertBatch(data).then(function (res) {
        self.saveDoing = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.quotationSuccess"),
            type: "success",
          });
          self.$router.push({ name: "pdmQuotations" });
        } else {
          self.sysError();
        }
      });
    },

    search() {
      this.loadData();
    },

    loadingMore() {
      const self = this;
      // console.log("====", self.combineParams());
      self.searchForm.currentPage = self.searchForm.currentPage + 1;
      self.loadingMoreDoing = true;
      Product.unQuoted(self.searchForm).then(function (res) {
        self.loadingMoreDoing = false;
        if (res.data.total !== 0) {
          let rs = [];
          res.data.records.forEach((d) => {
            const currentCurrencies = ls.session("CURRENCIES");
            let cnyRate = 1;
            const currencyObj = currentCurrencies.find(
              (r) => r.code === d.salesCurrency
            );
            if (currencyObj != null) {
              cnyRate = currencyObj.cnyRate;
            } else {
              cnyRate = 1;
            }
            let obj = {
              productId: d.id,
              price: d.salesPrice * cnyRate,
              hasInv: false,
              product: d,
              quotationSizePrices: d.sizes.map((s) => {
                return { size: s, price: null };
              }),
            };
            rs.push(obj);
          });
          self.records = self.records.concat(rs);

          if (self.records.length === self.pager.total) {
            self.loadingMoreDF = false;
            self.$message({
              message: self.$t("prompt.loadingComplete"),
              // message: self.$t("prompt.loadingComplete"),
              type: "warning",
            });
          } else {
            self.loadingMoreDF = true;
          }
          if (self.records.length >= self.maxQty) {
            self.loadingBeyondMaxQtyDF = true;
            self.$message({
              message: self.$t("prompt.loading500"),
              type: "warning",
            });
          }
        }
      });
    },
    //
    dataProvider(params) {
      return Product.unQuoted(params);
    },
    recordsDecorate(records) {
      this.records = this.buildTableData(records);
    },
    buildTableData(products) {
      const self = this;
      let rs = [];
      products.forEach((d) => {
        const currentCurrencies = ls.session("CURRENCIES");
        let cnyRate = 1;
        const currencyObj = currentCurrencies.find(
          (r) => r.code === d.salesCurrency
        );
        if (currencyObj != null) {
          cnyRate = currencyObj.cnyRate;
        } else {
          cnyRate = 1;
        }
        let obj = {
          productId: d.id,
          price: d.salesPrice * cnyRate,
          hasInv: false,
          product: d,
          quotationSizePrices: d.sizes.map((s) => {
            return { size: s, price: null };
          }),
        };
        rs.push(obj);
      });
      this.searchForm.customerId = this.combineParams().customerId;
      this.searchForm.currentPage = this.combineParams().currentPage;
      this.searchForm.pageSize = this.combineParams().pageSize;

      if (rs.length === this.pager.total) {
        this.loadingMoreDF = false;
        this.$message({
          message: this.$t("prompt.loadingComplete"),
          type: "warning",
        });
      } else {
        this.loadingMoreDF = true;
      }
      // if (rs.length > this.maxQty) {
      //   self.loadingTwoHundredDF = true;
      //   self.$message({
      //     message: self.$t("prompt.loading500"),
      //     type: "warning",
      //   });
      // }
      return rs;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>